import { createTableFilterSlice } from 'common/stores/redux/TableFilter';

const adminClientInvoiceFilterSlice = createTableFilterSlice(
    'adminClientInvoiceFilter'
);

export const {
    add,
    addAdvanced,
    remove,
    removeAll,
    setDefaultAdvancedFilters,
} = adminClientInvoiceFilterSlice.actions;

export default adminClientInvoiceFilterSlice.reducer;
